export enum BooleanType {
  True = 'True',
  False = 'False'
}
